import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

export class AppRouteReuseStrategy implements RouteReuseStrategy {
  private storedHandles = new Map<string, DetachedRouteHandle>();
  private cacheTimestamps = new Map<string, number>();
  private readonly CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

  private routesToCache = [/**'my-work'*/];

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const path = route.routeConfig?.path ?? '';
    return this.routesToCache.includes(path);
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    const path = route.routeConfig?.path ?? '';
    if (handle) {
      this.storedHandles.set(path, handle);
      this.cacheTimestamps.set(path, Date.now());
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const path = route.routeConfig?.path ?? '';
    if (!this.storedHandles.has(path)) {
      return false;
    }
    const timestamp = this.cacheTimestamps.get(path) ?? 0;
    if (Date.now() - timestamp > this.CACHE_DURATION) {
      this.storedHandles.delete(path);
      this.cacheTimestamps.delete(path);
      return false;
    }
    return true;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const path = route.routeConfig?.path ?? '';
    return this.storedHandles.get(path) ?? null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  clearCachedRoute(path: string): void {
    this.storedHandles.delete(path);
    this.cacheTimestamps.delete(path);
  }

  clearAllCachedRoutes(): void {
    this.storedHandles.clear();
    this.cacheTimestamps.clear();
  }
}
